import { render, staticRenderFns } from "./SystemAboutDialog.vue?vue&type=template&id=0a206452&"
import script from "./SystemAboutDialog.vue?vue&type=script&lang=js&"
export * from "./SystemAboutDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports